import LookupCategoriesRequestModelBase from '../_generated/modelBases/lookup-categories-request-model-base';

export default class LookupCategoriesRequestModel extends LookupCategoriesRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
